var _excluded = [
  'customImageUpload',
  'customVideoUpload',
  'getEditorResult',
  'style',
  'transformHtml',
  'htmlPosition',
  'readOnlyFlag',
  'getInit',
  'getTitle',
  'defaultTitle',
  'titleStyle',
];
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
      }
      _next(undefined);
    });
  };
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React, { useState, useEffect } from 'react';
import './style/index.css';
import { EDITOR_JS_TOOLS } from './tools';
import { getEditorJsTools } from './tools';
import { createReactEditorJS } from 'react-editor-js';
import editorHtml from 'editorjs-html';
//import editorParse from 'editorjs-parser';
var ReactEditorJS = createReactEditorJS();
var checklist = EDITOR_JS_TOOLS.checklist,
  quote = EDITOR_JS_TOOLS.quote,
  linkTool = EDITOR_JS_TOOLS.linkTool,
  image = EDITOR_JS_TOOLS.image,
  header = EDITOR_JS_TOOLS.header,
  list = EDITOR_JS_TOOLS.list;
var DocumentEditor = function DocumentEditor(props, ref) {
  var CHECK_LIST_STYLE =
    'display: inline-block; flex-shrink: 0;position: relative;width: 20px;height: 20px;margin: 5px;margin-left: -7px;margin-right: 7px;border-radius: 50%;border: 1px solid #d0d0d0;background: #fff;cursor: pointer;user-select: none;';
  var CHECKED_LIST_STYLE =
    'display: inline-block; flex-shrink: 0;position: relative;width: 20px;height: 20px;margin: 5px;margin-left: -7px;margin-right: 7px;border-radius: 50%;border: 1px solid #d0d0d0;background: #fff;cursor: pointer;user-select: none;background: #388ae5;border-color: #388ae5;';
  var YES_STYLE =
    "position: absolute;top: 6px;left: 5px;width: 9px;height: 4px;border: 2px solid #fff;border-top: none;border-right: none;background: transparent;transform: rotate(-45deg);content: '';opacity: 0;";
  var customImageUpload = props.customImageUpload,
    customVideoUpload = props.customVideoUpload,
    getEditorResult = props.getEditorResult,
    style = props.style,
    transformHtml = props.transformHtml,
    htmlPosition = props.htmlPosition,
    readOnlyFlag = props.readOnlyFlag,
    getInit = props.getInit,
    getTitle = props.getTitle,
    defaultTitle = props.defaultTitle,
    titleStyle = props.titleStyle,
    node = _objectWithoutProperties(props, _excluded);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    initInfo = _useState2[0],
    setDefaultInfo = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    configTitleValue = _useState4[0],
    setConfigTitleValue = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    dataHtml = _useState6[0],
    setDataHtml = _useState6[1];
  var _useState7 = useState({
      blocks: [],
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    transformData = _useState8[0],
    setTransformData = _useState8[1];
  var editorCore = React.useRef(null);
  var handleInitialize = React.useCallback(function (instance) {
    editorCore.current = instance;
  }, []);
  var handleSave = React.useCallback(
    /*#__PURE__*/ _asyncToGenerator(
      /*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
        var savedData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch ((_context.prev = _context.next)) {
              case 0:
                _context.next = 2;
                return editorCore.current.save();
              case 2:
                savedData = _context.sent;
                setDefaultInfo(savedData);
              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee);
      }),
    ),
    [],
  );
  var checklist = function checklist(_ref2) {
    var data = _ref2.data;
    return '<ol>\n    '.concat(
      data.items.map(function (it) {
        return '<li><input type="checkbox" checked=\''
          .concat(it.checked, "'>")
          .concat(it.text, '</li>');
      }),
      '\n    </ol>',
    );
  };
  var linkTool = function linkTool(_ref3) {
    var data = _ref3.data;
    return "<a href='".concat(data.link, "'></a>");
  };
  var video = function video(_ref4) {
    var data = _ref4.data;
    var caption = data.caption ? data.caption : 'video';
    return '<video src="'
      .concat(data.file && data.file.url ? data.file.url : data.url, '" alt="')
      .concat(caption, '" controls/>');
  };
  var configTitle = function configTitle(e) {
    setConfigTitleValue(e.target.value);
    getTitle(e.target.value);
  };
  useEffect(
    function () {
      getEditorJsTools({
        customImageUpload: customImageUpload,
        customVideoUpload: customVideoUpload,
      });
      if (readOnlyFlag) {
        var editParser = editorHtml();
        //   let html = editParser.parse(transformHtml || { blocks: [] });
        var html = editParser.parse(transformHtml);
        // 兼容回显图片大小
        // let htmlResp = html.map((item: string) => {
        //   if (item.includes('img') || item.includes('video')) {
        //     item = item.slice(0, 5) + "style='width:100%'" + ' ' + item.slice(5);
        //     return item;
        //   }
        //   return item;
        // });
        //setDataHtml(htmlResp.join(''));
        //处理只读模式下的多选列表的回显
        var convertedHtml = '';
        transformHtml.blocks.forEach(function (block) {
          switch (block.type) {
            case 'checklist':
              convertedHtml += "<ul style='list-style:none'>";
              block.data.items.forEach(function (li) {
                convertedHtml += '<li style="display:flex;line-height: 30px;"><span style=\''
                  .concat(li.checked ? CHECKED_LIST_STYLE : CHECK_LIST_STYLE, "'><i style='")
                  .concat(li.checked ? YES_STYLE : '', "'></i></span>")
                  .concat(li.text, '</li>');
              });
              convertedHtml += '</ul>';
              break;
          }
        });
        //setDataHtml(transformHtml.join(''));
        var newHtml = html.map(function (item) {
          if (!(typeof item === 'string')) {
            item = convertedHtml;
          }
          return item;
        });
        setDataHtml(newHtml.join(''));
      }
      getInit(editorCore);
      //内部保留相关的获取富文本编辑组件数据的方法
      // if (initInfo) {
      //         let results = editorHtml?.().validate(initInfo);
      //         let results2 = editorHtml?.({ checklist, linkTool, video }).parse(initInfo).join('');
      //         getEditorResult({ blockjson: results2, initInfo, title: configTitleValue });
      //     }
      //保留拓展的方法
      //  defaultValue={initInfo}
      //  value={data}
      setTimeout(function () {
        setTransformData(transformHtml);
      }, 400);
    },
    [transformData],
  );
  return /*#__PURE__*/ React.createElement(
    'div',
    {
      style: {
        width: '100%',
        height: '100%',
        background: '#fff',
        color: '#000',
      },
    },
    /*#__PURE__*/ React.createElement('span', {
      style: {
        color: '#000',
      },
    }),
    /*#__PURE__*/ React.createElement(
      'div',
      {
        style: style,
      },
      ' ',
      /*#__PURE__*/ React.createElement(
        'div',
        {
          style: titleStyle,
        },
        /*#__PURE__*/ React.createElement('input', {
          placeholder: '\u8BF7\u8F93\u5165\u6807\u9898',
          className: 'titleheader',
          disabled: readOnlyFlag,
          style: {
            height: '40px',
            outline: 'none',
            border: 'none',
            fontSize: 30,
            width: '100%',
            background: '#fff',
          },
          onChange: function onChange(e) {
            return configTitle(e);
          },
          value: defaultTitle,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        React.Fragment,
        null,
        readOnlyFlag
          ? /*#__PURE__*/ React.createElement('div', {
              dangerouslySetInnerHTML: {
                __html: dataHtml,
              },
              style: htmlPosition,
            })
          : /*#__PURE__*/ React.createElement(
              'div',
              null,
              /*#__PURE__*/ React.createElement(ReactEditorJS, {
                holder: 'custom',
                onInitialize: handleInitialize,
                autofocus: true,
                tools: getEditorJsTools({
                  customImageUpload: customImageUpload,
                  customVideoUpload: customVideoUpload,
                }),
                defaultValue: transformData,
                value: transformData,
                onChange: handleSave,
              }),
            ),
      ),
    ),
  );
};
export default DocumentEditor;
